import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/macro';

const ToggleWrapper = styled.div<{ clickable: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};
`;

const ToggleTrack = styled.div<{ isOn: boolean }>`
  position: relative;
  width: 48px;
  min-width: 48px;
  height: 26px;
  border-radius: 13px;
  background-color: ${({ isOn }) => (isOn ? '#34C759' : '#CCD2D7')};
  transition: background-color 0.2s ease-in-out;
`;

const ToggleThumb = styled.div<{ isOn: boolean }>`
  position: absolute;
  top: 3px;
  left: ${({ isOn }) => (isOn ? '25px' : '3px')};
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: left 0.2s ease-in-out;
`;

const StatusText = styled.span`
  color: #7F7F7F;
  font-family: acumin-pro;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
`;

const Toggle = ({
  isOn,
  onClick,
}: {
  isOn: boolean;
  onClick?: () => void;
}) => {
  const { t } = useTranslation();
  const status = isOn ? t('in-use') : t('not-in-use');
  return (
    <ToggleWrapper
      className="toggle"
      clickable={!!onClick}
      onClick={onClick}
      role={onClick ? 'switch' : undefined}
      aria-checked={onClick ? isOn : undefined}
    >
      <ToggleTrack isOn={isOn}>
        <ToggleThumb isOn={isOn} />
      </ToggleTrack>
      <StatusText>{status}</StatusText>
    </ToggleWrapper>
  );
};

export default Toggle;
